import { Primitive } from "../Primitive/Primitive.js";
import { createBlock, defineComponent, guardReactiveProps, normalizeProps, openBlock, renderSlot, unref, withCtx } from "vue";

//#region src/Calendar/CalendarGridBody.vue?vue&type=script&setup=true&lang.ts
var CalendarGridBody_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
	__name: "CalendarGridBody",
	props: {
		asChild: {
			type: Boolean,
			required: false
		},
		as: {
			type: null,
			required: false,
			default: "tbody"
		}
	},
	setup(__props) {
		const props = __props;
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(Primitive), normalizeProps(guardReactiveProps(props)), {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 16);
		};
	}
});

//#endregion
//#region src/Calendar/CalendarGridBody.vue
var CalendarGridBody_default = CalendarGridBody_vue_vue_type_script_setup_true_lang_default;

//#endregion
export { CalendarGridBody_default };
//# sourceMappingURL=CalendarGridBody.js.map